import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CommunicationService {
    constructor() { }
    private emitChangeSource = new Subject<any>();
    private emitRuleAdded = new Subject<any>();
    private emitFuncAdded = new Subject<any>();
    private radioChanged = new Subject<any>();
    private rolesReady = new Subject<any>();
    ruleAdded$ = this.emitRuleAdded.asObservable();
    changeEmitted$ = this.emitChangeSource.asObservable();
    funcAdded$ = this.emitFuncAdded.asObservable();
    radioChanged$ = this.radioChanged.asObservable();
    roleReady$ = this.rolesReady.asObservable();
    emitChange(data: {}) {
        this.emitChangeSource.next(data);
    }
    emitRuleAddition(data: {}) {
        this.emitRuleAdded.next(data);
    }
    emitFuncAddition(data: {}) {
        this.emitFuncAdded.next(data);
    }
    emitRadioSelection(data:{}) {
        this.radioChanged.next(data);
    }
    emitRolesReady(data: {}) {
        this.rolesReady.next(data);
    }
}